import { render, staticRenderFns } from "./MusicPlayer.vue?vue&type=template&id=47db2f3a&scoped=true&"
import script from "./MusicPlayer.vue?vue&type=script&lang=js&"
export * from "./MusicPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MusicPlayer.vue?vue&type=style&index=0&id=47db2f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db2f3a",
  null
  
)

export default component.exports